import MuiRating from '@mui/material/Rating'
import { Box } from '@mui/material'
import { SyntheticEvent } from 'react'
import { FlexRow } from '../layout/Flex'
import Label from '../display/Label'

type Props = {
  value?: number
  max?: number
  readOnly?: boolean
  label?: string
  precision?: number
  onChange?: (value: number) => void
}

export default function Rating({ value, max, readOnly, label, precision, onChange }: Props) {
  const handleChange = (e: SyntheticEvent, newValue: number | null) => {
    if (onChange && newValue) {
      onChange(newValue)
    }
  }

  return (
    <FlexRow align="center" space={0} scroll={false}>
      <MuiRating
        name="harf-rating"
        value={value ?? 0}
        max={max}
        precision={precision ?? 0.1}
        readOnly={readOnly}
        onChange={handleChange}
      />
      {label && (
        <Box pt={0.3} pl={1}>
          <Label text={label} />
        </Box>
      )}
    </FlexRow>
  )
}
